import { createAction, props } from '@ngrx/store';

import { FaqData } from '../../models/faq-data.model';

export const LoadFaqs = createAction('[Help FAQ] Load Faqs');

export const LoadFaqsSuccess = createAction(
  '[Help FAQ] Load Faqs Success',
  props<{ payload: { faqData: FaqData } }>()
);

export const LoadFaqsFailure = createAction(
  '[Help FAQ] Load Faqs Failure',
  props<{ payload: { error: string } }>()
);
